module.exports = __webpack_public_path__ + "static/media/facebook.ea7d0457.png";